import { useState, useCallback, useEffect } from 'react';
import { safeGetArray, safeSetJSON } from '@/lib/safeStorage';

interface MoodEntry {
  mood: string;
  timestamp: number;
}

const STORAGE_KEY = 'mood-history';

export const useMoodHistory = () => {
  const [history, setHistory] = useState<MoodEntry[]>([]);

  useEffect(() => {
    setHistory(safeGetArray<MoodEntry>(STORAGE_KEY));
  }, []);

  const addMood = useCallback((mood: string) => {
    const entry: MoodEntry = { mood, timestamp: Date.now() };
    const updated = [...safeGetArray<MoodEntry>(STORAGE_KEY), entry].slice(-30);
    safeSetJSON(STORAGE_KEY, updated);
    setHistory(updated);
  }, []);

  const last14Days = history.filter(
    (e) => Date.now() - e.timestamp < 14 * 24 * 60 * 60 * 1000
  );

  return { history: last14Days, addMood };
};
